import React, {useState} from 'react'
import QrReader from 'react-qr-scanner'
import {BasicProps} from "../Main";
import {Grid, MenuItem} from "@mui/material";
import {SamaggiField, SamaggiSelect} from "../Components/SamaggiFields";
import {Colours, SamaggiTypography} from "../Components/SamaggiTypography";
import {SamaggiButton} from "../Components/SamaggiButton";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {handleError} from "../support";

export const LegacyScanner: React.FC<BasicProps> = () => {
    const [result, setResult] = useState("NOT SCANNED");
    const [mode, setMode] = useState("CAM");
    const [valid, setValid] = useState("N/A");
    const [ticketType, setTicketType] = useState("NONE");
    const [buyer, setBuyer] = useState("N/A");
    const [lastScanned, setLastScanned] = useState("NEVER");
    const [numOtherTickets, setNumOtherTickets] = useState(0);
    const [event, setEvent] = useState("NONE");
    const [manualField, setManualField] = useState("");
    const [showScanner, setShowScanner] = useState(true)
    const [orderID, setOrderID] = useState("");

    const [statusColour, setStatusColour] = useState("#000000");

    const navigate = useNavigate();

    const previewStyle = {
        width: "100%"
    }

    function handleKeyDown(e: any) {
        if (e.key === 'Enter') {
            setResult(e.target.value);
            setManualField("");
            doRequest(e.target.value);
        }
    }

    function doRequest(data: string) {
        const token = localStorage.getItem("token");

        setStatusColour("#d59600");
        setShowScanner(false);

        const infoArgs = {
            "data": data
        }

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/postix-scanner/get-info", infoArgs).then((res) => {
            console.log(res);
            setStatusColour("#004dc0");

            setValid(res.data.data.valid);
            setTicketType(res.data.data.type);
            setBuyer(res.data.data.buyer);
            setLastScanned(res.data.data.lastScanned);
            setNumOtherTickets(res.data.data.numOtherTickets);
            setOrderID(res.data.data.orderID);
            setEvent(res.data.data.event);
        }).catch((error) => {
            setStatusColour("#da0000");

            handleError(error, true);
        })

        const usedArgs = {
            "token": token,
            "data": data
        }

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/postix-scanner/mark-used", usedArgs).then((res) => {
            console.log(res);
            setStatusColour("#00cb1b");
            setShowScanner(true);
        }).catch((error) => {
            setStatusColour("#da0000");
            setShowScanner(true);

            handleError(error, true);
        })
    }

    function markAllUsed(data: string) {
        if (data === "NOT SCANNED") {
            alert("Invalid Data.");
        }

        const token = localStorage.getItem("token");

        const usedArgs = {
            "token": token,
            "data": data,
            "all": true
        }

        setStatusColour("#d59600");

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/postix-scanner/mark-used", usedArgs).then((res) => {
            console.log(res);
            setStatusColour("#00cb1b");
            alert("Marked all as used.")
        }).catch((error) => {
            setStatusColour("#da0000");

            handleError(error, true);
        })
    }

    function dateFromEpoch(v: number) {
        const d = new Date(0);
        d.setUTCSeconds(v);
        return d
    }

    function handleScan(data: any) {
        if (data !== null) {
            if (data["text"] !== result) {
                setResult(data["text"]);
                doRequest(data["text"]);
            }
        }
    }

    function handleScanError(err: any){
        console.error(err)
    }

    return (
        <Grid container direction={"column"} spacing={4}>
            <Grid item>
                <SamaggiSelect label={"Mode"} value={mode} onChange={(e) => {setMode(e.target.value as string)}}>
                    <MenuItem value={"TYPE"}>Keyboard/Scanner</MenuItem>
                    <MenuItem value={"CAM"}>Camera</MenuItem>
                </SamaggiSelect>
            </Grid>
            <Grid item>
                {mode === "CAM" && showScanner && (
                    <QrReader delay={200} style={previewStyle} onError={handleScanError} onScan={handleScan} constraints={{
                        video: { facingMode: "environment" }
                    }}/>
                )}
                {mode ==="TYPE" && (
                    <SamaggiField onKeyDown={handleKeyDown} autoCapitalize="none" inputProps={{ autoCapitalize: 'none', }} value={manualField} onChange={(e) => {setManualField(e.target.value)}} label={"QR Data/Ticket Verification"}/>
                )}
            </Grid>
            <Grid item container direction={"column"} spacing={2}>
                <Grid item container direction={"column"}>
                    <Grid item>
                        <SamaggiTypography center small>Scan Result</SamaggiTypography>
                    </Grid>
                    <Grid item>
                        <SamaggiTypography center xlarge style={{color: statusColour}}>{result}</SamaggiTypography>
                    </Grid>
                </Grid>
                <Grid item container direction={"row"}>
                    <Grid item container direction={"column"} xs={12} md={6}>
                        <Grid item>
                            <SamaggiTypography center small>Valid</SamaggiTypography>
                        </Grid>
                        <Grid item>
                            <SamaggiTypography center xlarge bold colour={valid === "YES" ? Colours.green : (valid === "USED" ? Colours.darkYellow : Colours.red)}>{valid}</SamaggiTypography>
                        </Grid>
                    </Grid>
                    <Grid item container direction={"column"} xs={12} md={6}>
                        <Grid item>
                            <SamaggiTypography center small>Type</SamaggiTypography>
                        </Grid>
                        <Grid item>
                            <SamaggiTypography center xlarge>{ticketType}</SamaggiTypography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container direction={"column"}>
                    <Grid item>
                        <SamaggiTypography center small>Last Scanned</SamaggiTypography>
                    </Grid>
                    <Grid item>
                        <SamaggiTypography center xlarge>{lastScanned === "NEVER" ? "NEVER" : dateFromEpoch(parseFloat(lastScanned)).toLocaleString()}</SamaggiTypography>
                    </Grid>
                </Grid>
                <Grid item container direction={"row"}>
                    <Grid item container direction={"column"}>
                        <Grid item>
                            <SamaggiTypography center small>Buyer Name</SamaggiTypography>
                        </Grid>
                        <Grid item>
                            <SamaggiTypography center xlarge>{buyer}</SamaggiTypography>
                        </Grid>
                    </Grid>
                    <Grid item container direction={"column"}>
                        <Grid item>
                            <SamaggiTypography center small>Event</SamaggiTypography>
                        </Grid>
                        <Grid item>
                            <SamaggiTypography center xlarge>{event}</SamaggiTypography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container direction={"column"}>
                    <Grid item>
                        <SamaggiTypography center small>Order ID</SamaggiTypography>
                    </Grid>
                    <Grid item>
                        <SamaggiTypography center xlarge>{orderID}</SamaggiTypography>
                    </Grid>
                </Grid>
                <Grid item container direction={"column"}>
                    <Grid item>
                        <SamaggiTypography center small>Buyer Name</SamaggiTypography>
                    </Grid>
                    <Grid item>
                        <SamaggiTypography center xlarge>{buyer}</SamaggiTypography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item container direction={"column"} spacing={3}>
                {numOtherTickets > 0 && (
                    <Grid item>
                        <SamaggiButton fullWidth onClick={() => {markAllUsed(result)}}>Mark {numOtherTickets} other tickets as used</SamaggiButton>
                    </Grid>
                )}
                <Grid item>
                    <SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray} onClick={() => navigate("/")}>Back</SamaggiButton>
                </Grid>
            </Grid>
        </Grid>
    )
}
